<template>
  <div
    v-if="relatedLink.url || downloadFiles.length"
    class="download_and_weburl"
  >
    <ul>
      <li>
        <a
          v-if="relatedLink.url"
          target="_blank"
          :title="'[另開新視窗]' + relatedLink.name"
          :href="relatedLink.url"
        >
          <LinkOutlined
            :style="{
              marginRight: '16px',
            }"
          />
          相關連結：
          {{ relatedLink.name }}</a
        >
      </li>
      <li v-for="{ fileId, fileName } in downloadFiles" :key="fileId">
        <a
          :title="fileName"
          @click.prevent="
            downloadFile({
              fileId,
              fileName,
            })
          "
        >
          <DownloadOutlined
            :style="{
              marginRight: '16px',
            }"
          />
          檔案下載：
          {{ fileName }}</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { LinkOutlined, DownloadOutlined } from "@ant-design/icons-vue";
import { getDownloadFileAPI } from "@/api/api.js";

export default {
  props: {
    relatedLink: Object,
    downloadFiles: Array,
  },
  components: { LinkOutlined, DownloadOutlined },
  setup() {
    const downloadFile = async ({ fileId, fileName }) => {
      const fileType = getFileType(fileName);

      try {
        const res = await getDownloadFileAPI(fileId);
        const fileUrl = toDownloadUrl({ fileData: res.data, fileType });
        download({ fileUrl, fileName });

        window.URL.revokeObjectURL(fileUrl);
      } catch (error) {
        console.log(error);
      }
    };

    const getFileType = (fileName) => {
      const fileNameArray = fileName.split(".");
      const fileType = fileNameArray[fileNameArray.length - 1].toLowerCase();
      return fileType;
    };

    const toDownloadUrl = ({ fileData, fileType }) => {
      const type =
        fileType === "zip" || fileType === "pdf"
          ? `application/${fileType}`
          : `image/${fileType}`;

      return window.URL.createObjectURL(
        new Blob([fileData], {
          type,
        })
      );
    };

    const download = ({ fileUrl, fileName }) => {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = fileUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    };

    return { downloadFile };
  },
};
</script>

<style lang="scss" scoped>
.download_and_weburl {
  padding-top: 40px;
  text-align: start;

  li {
    margin-bottom: 4px;
    a {
      font-size: 16px;
    }
  }
}
</style>
